export { ConfigComponent } from './config.component';
export { Config } from './config.model';
export { ConfigService } from './config.service';
export { ConfigServiceMock } from './config.service.mock';
